import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as serviceCenters from '../../service-centers'

export const RESOURCE = {
  payload: {
    description:
      'A specialized unit within an institution that provides a particular service to multiple organizational units. (e.g., vivariums, print centers, etc.)',
    dimension: serviceCenters.RESOURCE.payload,
    level: 0,
    name: 'Service Center',
    partialId: PartialId.Standard.create('svc_center'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
